import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonContent
} from '@ionic/react'
import { NewsSwipper } from '../../../components/common/NewsSwipper'
import './styles.scss'

const NoLive = () => {
  return (
    <IonContent
      fullscreen
      className='no-live page-wrapper'
    >
      <section className='notification'>
        <h1>
          ¡Ups, esto es un poco vergonzoso!
          <span role='img' aria-label='emoji sorprendido'> &#128551;</span>
        </h1>
        <p>
          En este momento no tenemos programación disponible, puedes pasar luego
          <span role='img' aria-label='emoji sonrisa de pena'> &#128517;</span>
        </p>
      </section>

      <section className='navigation'>
        <h2>
          Puedes hecharle un ojo a alguno de estos enlaces
          <span role='img' aria-label='emoji pensativo'> &#129300;</span>
        </h2>
        <div className='links'>
          <Link to='/'>Home</Link>
          <Link to='/originales/explorar'>Radio</Link>
          <Link to='/news/1'>News</Link>
        </div>
      </section>

      <h2
        className='read-news'
      >
        Tambien puedes leer alguna de estas
        <span role='img' aria-label='emoji anteojo de un ojo'> &#129488;</span>
      </h2>
      <NewsSwipper />
    </IonContent>
  )
}

export default NoLive
